import { render, staticRenderFns } from "./WebsiteCustomerAddresses.vue?vue&type=template&id=36191d30&"
import script from "./WebsiteCustomerAddresses.vue?vue&type=script&lang=js&"
export * from "./WebsiteCustomerAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports